module.exports = __webpack_public_path__ + "static/complex_video-15211947b61b5c2b37df6fba3112d67a.mp4";